import type { HomeSettings } from '~/features/home/utils/homeSettings';
import type { ServiceRequestConfig } from '~/services/createService';

import { updateHomeSettings } from '../userPreferences';
import { serializeScopeWrite } from './serializeScopeWrite';

export type StoreHomeCopyRequest = {
  settings: HomeSettings;
};

export function storeHomeCopy(
  { settings }: StoreHomeCopyRequest,
  options: ServiceRequestConfig = {},
) {
  return serializeScopeWrite(async (currentSettings) => {
    const copy = currentSettings(settings);
    await updateHomeSettings({ homeSettings: copy }, options);
    return { settings: copy };
  });
}
